import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Card, CardActions, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core';
import { AppSnackbar, CardTitle } from '@sierralabs/core-ui';
import { useSiteContext } from '../SiteContext';
import { Link } from 'react-router-dom';
import { useFindSites } from '../hooks/site/useFindSites';
import SiteMenuButton from '../common/site-menu-button/SiteMenuButton';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  .flex {
    flex: 1;
  }
  .loading,
  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 50%;
    padding: 24px;
  }
`;
const SiteList = () => {
    const { editorPath, setConfigureComponent } = useSiteContext();
    const getSiteUrl = (site) => {
        const params = new URLSearchParams({ path: site.path }).toString();
        return `${editorPath}sites/${site.id}?${params}`;
    };
    const { sites, loadingSites, loadingSitesError: loadingSiteError, findSites } = useFindSites();
    useEffect(() => {
        findSites();
        // make sure any previous selected component is unselected
        setConfigureComponent(undefined);
    }, [findSites, setConfigureComponent]);
    return (React.createElement(StyledDiv, { className: 'site-list' },
        loadingSites ? (React.createElement("div", { className: 'loading' },
            React.createElement(CircularProgress, { size: 32 }))) : !sites || sites.data.length === 0 ? (React.createElement("div", { className: 'empty-state' },
            React.createElement(Typography, { variant: 'overline' }, "No Sites found"))) : (React.createElement(Grid, { container: true, spacing: 2 }, sites.data.map(site => (React.createElement(Grid, { item: true, xs: 12, sm: 8, md: 3, key: site.id },
            React.createElement(Card, null,
                React.createElement(CardTitle, { className: 'card-title' },
                    "Site",
                    React.createElement("div", { className: 'flex' }),
                    React.createElement(SiteMenuButton, { key: site.id, siteId: site.id })),
                React.createElement(CardContent, null,
                    React.createElement(Typography, { variant: 'h5' }, site.name),
                    React.createElement(Typography, { variant: 'body1' },
                        "Domain: ",
                        site.domain),
                    React.createElement(Typography, { variant: 'body1' },
                        "Path: ",
                        site.path)),
                React.createElement(CardActions, null,
                    React.createElement(Button, { fullWidth: true, variant: 'outlined', color: 'primary', component: Link, to: getSiteUrl(site) }, "Edit Site")))))))),
        loadingSiteError && (React.createElement(AppSnackbar, { open: true, severity: 'error' }, loadingSiteError.message || 'Loading site error'))));
};
export default SiteList;
//# sourceMappingURL=SiteList.js.map